<script setup>
import { computed } from "vue";

const props = defineProps({
  values: { type: Array, required: true },
  color: { type: String, default: "#38bdf8" },
  fill: { type: String, default: "rgba(56,189,248,.16)" },
});

const W = 74;
const H = 26;

const paths = computed(() => {
  const v = props.values;
  if (!v.length) return { line: "", fill: "" };
  const mn = Math.min(...v);
  const mx = Math.max(...v);
  const rng = mx - mn || 1;
  const pts = v.map((val, i) => {
    const x = v.length > 1 ? (i / (v.length - 1)) * W : W / 2;
    const y = H - 2 - ((val - mn) / rng) * (H - 4);
    return [x, y];
  });
  const line = pts.map((p, i) => `${i ? "L" : "M"}${p[0].toFixed(1)} ${p[1].toFixed(1)}`).join(" ");
  return { line, fill: `${line} L${W} ${H} L0 ${H} Z` };
});
</script>

<template>
  <svg class="an-spark" :viewBox="`0 0 ${W} ${H}`" preserveAspectRatio="none" aria-hidden="true">
    <path :d="paths.fill" :fill="fill" />
    <path
      :d="paths.line"
      fill="none"
      :stroke="color"
      stroke-width="2"
      vector-effect="non-scaling-stroke"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
